module.exports = __webpack_public_path__ + "img/15-l.963ca208.png";